import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaChartLine, FaLeaf, FaLightbulb } from 'react-icons/fa';
import SectionTitle from '../layout/SectionTitle';

const Advantages = () => {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-white py-8">
      <div className="container mx-auto px-4">
        <SectionTitle 
          overline={t('mining.advantages.title')} 
          highlight="" 
          separatorColor="socabeg-blue" 
          showLogo={true} 
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8 md:grid-rows-1">
          {/* Colonne 1 - Image 1 */}
          <div className="flex flex-col h-full">
            {/* Image */}
            <div className="h-full flex-grow">
              <img 
                src="/images/mines5.jpg" 
                alt="Mining Operations" 
                className="w-full h-full object-cover" 
                style={{ minHeight: '100%' }}
              />
            </div>
          </div>

          {/* Colonne 2 - ATOUTS, MARCHÉ et ENGAGEMENT ESG */}
          <div className="flex flex-col h-full">
            
            {/* MARCHÉ */}
            <div className="bg-socabeg-blue text-white p-6 flex-grow">
              <div className="flex items-center mb-4">
                <div className="mr-3">
                  <FaChartLine className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold uppercase border-b border-white pb-2">{t('mining.market.title')}</h3>
              </div>
              <ul className="list-disc pl-5 mb-8 space-y-2">
                <li>{t('mining.market.point1')}</li>
                <li>{t('mining.market.point2')}</li>
              </ul>

              {/* ENGAGEMENT ESG */}
              <div className="flex items-center mb-4">
                <div className="mr-3">
                  <FaLeaf className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold uppercase border-b border-white pb-2">{t('mining.esg.title')}</h3>
              </div>
              <ul className="list-disc pl-5 mb-8 space-y-2">
                <li>{t('mining.esg.point1')}</li>
                <li>{t('mining.esg.point2')}</li>
              </ul>
              
              {/* POURQUOI INVESTIR */}
              <div className="flex items-center mb-4">
                <div className="mr-3">
                  <FaLightbulb className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold uppercase border-b border-white pb-2">{t('mining.whyInvest.title')}</h3>
              </div>
              <ul className="list-disc pl-5 space-y-2">
                <li>{t('mining.whyInvest.point1')}</li>
                <li>{t('mining.whyInvest.point2')}</li>
                <li>{t('mining.whyInvest.point3')}</li>
                <li>{t('mining.whyInvest.point4')}</li>
              </ul>
            </div>
          </div>
          
          {/* Colonne 3 - Image 2 */}
          <div className="flex flex-col h-full">
            <div className="h-full flex-grow">
              <img 
                src="/images/mines6.jpg" 
                alt="Mines 6" 
                className="w-full h-full object-cover" 
                style={{ minHeight: '100%' }}
              />
            </div>
          </div>
        </div>
        
      </div>
    </section>
  );
};

export default Advantages;
